import { render } from "./form_cotisation.vue?vue&type=template&id=01fca150&scoped=true"
import script from "./form_cotisation.vue?vue&type=script&lang=js"
export * from "./form_cotisation.vue?vue&type=script&lang=js"

import "../../../assets/css/modal.css?vue&type=style&index=0&id=01fca150&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01fca150"]])

export default __exports__